/* DIREVULF — product page: size guide tabs, "Not sure? Find my size",
   compact summary, and Wear guide · Live.

   Nothing here invents a number. The size tools do arithmetic on the
   product's own Size guide rows (and the merchant's own Size rules, when a
   product has them). The weather card shows only what Open-Meteo returns and
   stays quiet when it returns nothing. */
(function () {
  'use strict';
  if (window.__dvSizeGuide) return;
  window.__dvSizeGuide = true;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function num(t) { var n = parseFloat(String(t == null ? '' : t).replace(/[^0-9.]/g, '')); return isFinite(n) ? n : null; }
  function fmt(n) { return (Math.round(n * 10) / 10).toString(); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function store(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) { return null; } return null; }

  /* ---------------- size guide tabs ---------------- */
  function select(dialog, tab, focus) {
    $$('[role="tab"]', dialog).forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    var row = tab.parentNode;
    var rb = row.getBoundingClientRect(), tb = tab.getBoundingClientRect();
    if (tb.left < rb.left + 8) row.scrollLeft -= (rb.left + 16 - tb.left);
    else if (tb.right > rb.right - 8) row.scrollLeft += (tb.right - rb.right + 16);
    var body = $('.dv-sg__body', dialog);
    if (body) body.scrollTop = 0;
    if (focus) tab.focus();
  }
  function initTabs(dialog) {
    var tabs = $$('[role="tab"]', dialog);
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(dialog, t, false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        else if (k === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (k === 'Home') n = tabs[0];
        else if (k === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); select(dialog, n, true); }
      });
    });
  }

  /* ---------------- choosing a size on the page ---------------- */
  function pageSizeInput(value) {
    var inputs = $$('.dv-variants__group--size input.dv-size__input');
    for (var i = 0; i < inputs.length; i++) if (inputs[i].value === value) return inputs[i];
    return null;
  }
  function pickButtons(names) {
    var html = '';
    names.forEach(function (n) {
      var inp = pageSizeInput(n);
      if (inp && !inp.disabled) html += '<button type="button" data-sg-pick="' + esc(n) + '">Select ' + esc(n) + '</button>';
    });
    return html ? '<div class="dv-sg__pick">' + html + '</div>' : '';
  }
  function closeDialog(dialog) {
    if (window.DirevulfOverlay && window.DirevulfOverlay.active === dialog) window.DirevulfOverlay.close();
    else if (dialog.open) dialog.close();
  }
  function initPick(dialog) {
    dialog.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sg-pick]');
      if (!b) return;
      var inp = pageSizeInput(b.getAttribute('data-sg-pick'));
      if (!inp) return;
      var lab = document.querySelector('label[for="' + inp.id + '"]');
      closeDialog(dialog);
      (lab || inp).click();
    });
  }

  /* ---------------- find my size: chart rows ---------------- */
  function chartFrom(dialog) {
    var node = $('[data-fms-rows]', dialog);
    if (!node) return null;
    var rows;
    try { rows = JSON.parse(node.textContent); } catch (e) { return null; }
    if (!Array.isArray(rows) || rows.length < 2) return null;
    var head = rows[0].map(String);
    var sold = dialog.getAttribute('data-sg-sold') || '';
    var body = rows.slice(1).filter(function (r) { return Array.isArray(r) && r.length; });
    var filtered = sold ? body.filter(function (r) { return sold.indexOf('|' + r[0] + '|') !== -1; }) : body;
    if (filtered.length) body = filtered;
    function col(re, not) {
      for (var i = 1; i < head.length; i++) if (re.test(head[i]) && !(not && not.test(head[i]))) return i;
      return -1;
    }
    var unitName = (dialog.getAttribute('data-sg-unit') || '').toLowerCase();
    /* A chart whose chest column is a BODY measurement ("To Fit Your Chest
       Size") can't be compared with a garment's chest, so no garment-based
       recommendation is made for it; the shopper reads the chart instead. */
    var chestCol = col(/chest/i);
    var bodyChart = chestCol > 0 && /(to fit|body)/i.test(head[chestCol]);
    return {
      head: head,
      rows: body.map(function (r) { return r.map(String); }),
      chest: bodyChart ? -1 : chestCol,
      body: bodyChart ? head[chestCol] : '',
      length: col(/length/i, /sleeve/i),
      unit: /inch/.test(unitName) ? '"' : (unitName ? ' ' + unitName : '')
    };
  }

  function initFindMySize(dialog) {
    var chart = chartFrom(dialog);
    var garment = dialog.getAttribute('data-sg-garment') === 'shirt' ? 'shirt' : 'tee';
    var panel = $('[data-fms-compare]', dialog);

    /* What you're wearing */
    if (panel && chart) {
      var U = chart.unit;
      var u = function (n) { return fmt(n) + U; };
      var chips = $('[data-fms-chips]', panel);
      var out = $('[data-sg-out]', panel);
      var current = null;

      chart.rows.forEach(function (r) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dv-sg__chip';
        b.textContent = r[0];
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          var on = b.getAttribute('aria-pressed') !== 'true';
          $$('.dv-sg__chip', chips).forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          current = on ? r : null;
          compare(true);
        });
        chips.appendChild(b);
      });

      var rowFor = function (size) { return chart.rows.filter(function (r) { return r[0] === size; })[0]; };
      var facts = function (r) {
        var parts = [];
        for (var i = 1; i < chart.head.length; i++) if (r[i] !== '') parts.push(esc(chart.head[i]) + ' <strong>' + esc(r[i]) + U + '</strong>');
        return parts.join(' · ');
      };

      var compare = function (fromChip) {
        var raw = num($('[data-sg-chest]', panel).value);
        var lenIn = num($('[data-sg-length]', panel).value);
        var method = ($('[data-sg-method]:checked', panel) || {}).value || 'flat';

        /* Only a size picked, no measurement: show this product's own numbers
           for that size and point to the chart. No recommendation. */
        if ((raw == null || raw <= 0) || chart.chest < 0) {
          if (!current) {
            if (fromChip) { out.hidden = true; return; }
            out.innerHTML = chart.body
              ? '<p style="margin:0">This size chart is by body measurement. Measure all the way round your chest and pick the size whose “' + esc(chart.body) + '” matches it.</p>'
              : '<p style="margin:0">Compare your garment measurements with our Size Chart.</p>';
            out.hidden = false; return;
          }
          out.innerHTML =
            '<div class="dv-fms__vs">' +
              '<div><p class="dv-fms__k">Your garment</p><p class="dv-fms__v">' + esc(current[0]) + '</p><p class="dv-fms__s">Measurement not entered</p></div>' +
              '<div><p class="dv-fms__k">DIREVULF</p><p class="dv-fms__v">' + esc(current[0]) + '</p><p class="dv-fms__s">' + (chart.chest > 0 ? u(num(current[chart.chest])) + ' garment chest' : '') + '</p></div>' +
            '</div>' +
            '<p class="dv-fms__facts">' + facts(current) + '</p>' +
            (chart.body
              ? '<p>Sizes vary between brands, so the same letter can fit differently. This chart is by body measurement — measure round your chest and match it to “' + esc(chart.body) + '”.</p>'
              : '<p>Sizes vary between brands, so the same letter can fit differently. Compare your garment measurements with our Size Chart, or enter your ' + garment + '’s chest below.</p>');
          out.hidden = false; return;
        }

        var chest = method === 'flat' ? raw * 2 : raw;
        var list = chart.rows.map(function (r) { return { r: r, c: num(r[chart.chest]) }; }).filter(function (x) { return x.c != null; });
        list.sort(function (a, b) { return a.c - b.c; });
        if (!list.length) {
          out.innerHTML = '<p style="margin:0">Compare your garment measurements with our Size Chart.</p>';
          out.hidden = false; return;
        }
        var picks = [], note = '';
        var first = list[0], last = list[list.length - 1];
        if (chest < first.c) { picks = [first]; note = 'Your garment is smaller than our smallest size here.'; }
        else if (chest > last.c) { picks = [last]; note = 'Your garment is bigger than our largest size here.'; }
        else {
          for (var i = 0; i < list.length; i++) {
            if (list[i].c === chest) { picks = [list[i]]; break; }
            if (i < list.length - 1 && chest > list[i].c && chest < list[i + 1].c) { picks = [list[i], list[i + 1]]; note = 'Your garment sits between two of our sizes.'; break; }
          }
        }
        var diff = function (c) { var d = c - chest; return (d > 0 ? '+' : d < 0 ? '−' : '±') + fmt(Math.abs(d)) + U; };
        var names = picks.map(function (p) { return p.r[0]; });
        var lenLine = '';
        if (lenIn != null && lenIn > 0 && chart.length > 0) {
          lenLine = picks.map(function (p) {
            var L = num(p.r[chart.length]); if (L == null) return '';
            var d = L - lenIn;
            return esc(p.r[0]) + ' is ' + u(L) + ' long (' + (d === 0 ? 'same as yours' : fmt(Math.abs(d)) + U + ' ' + (d > 0 ? 'longer' : 'shorter')) + ').';
          }).filter(Boolean).join(' ');
        }
        out.innerHTML =
          '<div class="dv-fms__vs">' +
            '<div><p class="dv-fms__k">Your garment</p><p class="dv-fms__v">' + (current ? esc(current[0]) : '—') + '</p><p class="dv-fms__s">' + u(chest) + ' chest' + (method === 'flat' ? ' (' + u(raw) + ' × 2)' : '') + '</p></div>' +
            '<div><p class="dv-fms__k">DIREVULF</p><p class="dv-fms__v">' + names.map(esc).join(' / ') + '</p><p class="dv-fms__s">' + picks.map(function (p) { return u(p.c); }).join(' / ') + ' garment chest</p></div>' +
          '</div>' +
          '<dl class="dv-sg__kv"><dt>Closest match</dt><dd>' + names.map(esc).join(' / ') + '</dd>' +
          '<dt>Difference</dt><dd>' + picks.map(function (p) { return esc(p.r[0]) + ' ' + diff(p.c); }).join(' · ') + '</dd></dl>' +
          (note ? '<p>' + note + '</p>' : '') +
          (lenLine ? '<p>' + lenLine + '</p>' : '') +
          '<p class="dv-sg__fine" style="margin-top:8px">Based on chest measurement' + (lenLine ? ' and the length you entered' : '') + ' only — a guide, not a guarantee. Check shoulder and length in the size chart too.</p>' +
          pickButtons(names);
        out.hidden = false;
      };
      var btn = $('[data-sg-compare-btn]', panel);
      if (btn) btn.addEventListener('click', function () { compare(false); });
      $$('input[type="number"]', panel).forEach(function (i) {
        i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); compare(false); } });
      });
    }

    /* Height, weight, build — the merchant's own Size rules only */
    var rb = $('[data-fms-rules]', dialog);
    if (rb) {
      var rules = [];
      try { rules = JSON.parse(($('[data-fms-rules-json]', rb) || {}).textContent || '[]'); } catch (e) { rules = []; }
      var build = 'Regular';
      var ins = {};
      $$('[data-fms-in]', rb).forEach(function (el) {
        ins[el.getAttribute('data-fms-in')] = el;
        var o = $('[data-fms-out="' + el.getAttribute('data-fms-in') + '"]', rb);
        var paint = function () { if (o) o.textContent = el.value + ' ' + el.getAttribute('data-unit'); };
        el.addEventListener('input', paint); paint();
      });
      $$('[data-fms-build]', rb).forEach(function (b) {
        b.addEventListener('click', function () {
          build = b.getAttribute('data-fms-build');
          $$('[data-fms-build]', rb).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        });
      });
      var inRange = function (v, r) { return !Array.isArray(r) || r.length < 2 || (v >= Number(r[0]) && v <= Number(r[1])); };
      var go = $('[data-fms-rules-go]', rb), res = $('[data-fms-rules-out]', rb);
      if (go) go.addEventListener('click', function () {
        var h = Number(ins.height ? ins.height.value : 0), w = Number(ins.weight ? ins.weight.value : 0), hit = null;
        for (var i = 0; i < rules.length; i++) {
          var r = rules[i] || {};
          if (!inRange(h, r.height_cm) || !inRange(w, r.weight_kg)) continue;
          if (Array.isArray(r.build) && r.build.length && r.build.indexOf(build) === -1) continue;
          hit = { r: r, i: i }; break;
        }
        if (!hit || !hit.r.size) {
          res.innerHTML = '<p style="margin:0">Your height and weight sit outside the sizing we hold for this product. Try “What you’re wearing” below, or check the size chart.</p>';
        } else {
          var next = rules[hit.i + 1];
          res.innerHTML = '<dl class="dv-sg__kv"><dt>Your likely size</dt><dd>' + esc(hit.r.size) + '</dd></dl>' +
            (next && next.size ? '<p>Prefer it looser? Size up to ' + esc(next.size) + '.</p>' : '') +
            '<p class="dv-sg__fine" style="margin-top:8px">From this product’s own sizing, not a guarantee.</p>' + pickButtons([String(hit.r.size)]);
        }
        res.hidden = false;
      });
    }
  }

  /* ---------------- compact summary ---------------- */
  function initSummary() {
    $$('[data-dv-summary]').forEach(function (box) {
      var btn = $('[data-dv-summary-toggle]', box), text = $('.pdp2-summary__text', box);
      if (!btn || !text) return;
      if (text.scrollHeight > text.clientHeight + 2) btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-collapsed') === false;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Read less' : 'Read more';
      });
    });
  }

  /* ---------------- wear guide · live ---------------- */
  var WMO = { 0: 'Clear', 1: 'Mainly clear', 2: 'Partly cloudy', 3: 'Overcast', 45: 'Fog', 48: 'Fog', 51: 'Light drizzle', 53: 'Drizzle', 55: 'Heavy drizzle', 56: 'Freezing drizzle', 57: 'Freezing drizzle', 61: 'Light rain', 63: 'Rain', 65: 'Heavy rain', 66: 'Freezing rain', 67: 'Freezing rain', 71: 'Light snow', 73: 'Snow', 75: 'Heavy snow', 77: 'Snow grains', 80: 'Rain showers', 81: 'Rain showers', 82: 'Heavy showers', 85: 'Snow showers', 86: 'Snow showers', 95: 'Thunderstorm', 96: 'Thunderstorm', 99: 'Thunderstorm' };
  function getJSON(url) {
    return fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function initWear() {
    var card = $('[data-dv-wear]');
    if (!card) return;
    var reading = $('[data-wear-now]', card), msg = $('[data-wear-msg]', card), form = $('[data-wear-form]', card);
    var input = $('[data-wear-city]', card), change = $('[data-wear-change]', card), loc = $('[data-wear-loc]', card);
    var pin = $('[data-wear-pin]', card), meter = $('[data-wear-meter]', card);
    var meterLabel = meter ? meter.getAttribute('aria-label') : '';
    /* Three compact cards under the meter (fabric, fit, right now). Copy comes
       from the product as {cards:[{k1,k2},{k1,k2}], base, bands:[{max,a,b,c}]}
       with bands ascending by max (°C, inclusive, rounded temperature). */
    var box = $('[data-wear-tips]', card), T = null;
    if (box) { try { T = JSON.parse(box.getAttribute('data-tips') || 'null'); } catch (e) { T = null; } }
    if (!T || !T.bands || !T.bands.length) T = null;
    function bandIndex(t) {
      for (var i = 0; i < T.bands.length; i++) if (typeof T.bands[i].max === 'number' && t <= T.bands[i].max) return i;
      return T.bands.length - 1;
    }
    function bandFor(t) { return T.bands[bandIndex(t)]; }

    /* The weather in the words the tip pool uses. WMO codes as Open-Meteo
       reports them; wind in km/h; humidity in %. */
    function conditionsOf(cur) {
      var c = {}, code = cur && cur.weather_code;
      if (code === 0 || code === 1) c.clear = true;
      else if (code === 2 || code === 3 || code === 45 || code === 48) c.cloudy = true;
      else if (code >= 51 && code <= 57) c.drizzle = true;
      else if ((code >= 61 && code <= 67) || (code >= 80 && code <= 82)) c.rain = true;
      else if (code >= 95) c.storm = true;
      if (cur && typeof cur.wind_speed_10m === 'number' && cur.wind_speed_10m >= 25) c.windy = true;
      if (cur && typeof cur.relative_humidity_2m === 'number' && cur.relative_humidity_2m >= 75) c.humid = true;
      return c;
    }

    /* RIGHT NOW line. Only tips for this temperature band are candidates;
       tips tied to weather ("w") count only when that weather is happening.
       In rain, drizzle or a storm the weather-specific tips lead (general ones
       join only if fewer than two fit). The tip shown last time is left out
       whenever another one fits, then one of the rest is picked at random, so
       a reload in the same weather shows a different, still relevant line.
       Only the tip's short id is remembered — nothing about the shopper. */
    var LAST_TIP = 'dv:wear:tip';
    function pickTip(t, cur) {
      var pool = T.tips || [];
      var bi = bandIndex(t);
      if (!pool.length) return { id: '', text: bandFor(t).c || '' };
      var c = conditionsOf(cur);
      var inBand = pool.filter(function (p) { return p && p.t && (p.b || []).indexOf(bi) !== -1; });
      var specific = inBand.filter(function (p) { return p.w && p.w.some(function (w) { return c[w]; }); });
      var general = inBand.filter(function (p) { return !p.w || !p.w.length; });
      var wet = c.drizzle || c.rain || c.storm;
      var eligible = wet && specific.length >= 2 ? specific : general.concat(specific);
      if (!eligible.length) return { id: '', text: bandFor(t).c || '' };
      var last = store(LAST_TIP);
      var fresh = eligible.filter(function (p) { return p.id !== last; });
      var from = fresh.length ? fresh : eligible;
      var tip = from[Math.floor(Math.random() * from.length)];
      store(LAST_TIP, String(tip.id));
      return { id: tip.id, text: tip.t };
    }
    function put(sel, text) { var el = $(sel, box); if (el) el.textContent = text || ''; }
    /* t = rounded live temperature, or null when there is no live reading. */
    function setTips(t, note, cur) {
      if (!T) return;
      (T.cards || []).forEach(function (c, i) { put('[data-tc-k1="' + i + '"]', c.k1); put('[data-tc-k2="' + i + '"]', c.k2); });
      var b = t == null ? (T.bands[T.base] || T.bands[0]) : bandFor(t);
      put('[data-tc="a"]', b.a); put('[data-tc="b"]', b.b);
      put('[data-tc-temp]', t == null ? '' : t + '°C');
      var tip = t == null ? null : pickTip(t, cur);
      put('[data-tc="c"]', t == null ? (note || '') : tip.text);
      var cEl = $('[data-tc="c"]', box);
      if (cEl) { if (tip && tip.id) cEl.setAttribute('data-tip-id', tip.id); else cEl.removeAttribute('data-tip-id'); }
      box.classList.toggle('is-live', t != null);
    }
    setTips(null, '');
    var LO = 10, HI = 44;

    /* Two fixed-height slots: reading | form above the meter, button | message
       below it. Swapping what fills a slot never changes the card's height. */
    function note(text) { change.hidden = true; msg.hidden = false; msg.textContent = text; msg.title = text; }
    function loading(place) {
      card.classList.add('is-loading');
      reading.hidden = false; form.hidden = true; setTips(null, '');
      note('Checking the weather in ' + place + '…');
    }
    function ask(text) {
      card.classList.remove('is-loading');
      reading.hidden = true; form.hidden = false;
      loc.hidden = true; loc.textContent = '';
      $('[data-wear-temp]', card).textContent = ''; $('[data-wear-cond]', card).textContent = '';
      if (pin) pin.classList.remove('is-on');
      setTips(null, 'Enter a city above for today’s styling tip.');
      if (meter) meter.setAttribute('aria-label', meterLabel);
      note(text);
    }
    function paint(place, cur) {
      var t = Math.round(cur.temperature_2m);
      $('[data-wear-temp]', card).textContent = t;
      var bits = [WMO[cur.weather_code] || ''];
      if (cur.relative_humidity_2m != null) bits.push(Math.round(cur.relative_humidity_2m) + '% humidity');
      $('[data-wear-cond]', card).textContent = bits.filter(Boolean).join(' · ');
      loc.textContent = place; loc.title = place; loc.hidden = false;
      if (pin) {
        pin.style.left = Math.max(0, Math.min(100, (cur.temperature_2m - LO) / (HI - LO) * 100)) + '%';
        pin.classList.add('is-on');
      }
      setTips(t, '', cur);
      if (meter) meter.setAttribute('aria-label', meterLabel + '. Now ' + t + '°C in ' + place + '.');
      card.classList.remove('is-loading');
      reading.hidden = false; form.hidden = true; msg.hidden = true; change.hidden = false;
    }
    function load(place, lat, lon) {
      loading(place);
      var url = 'https://api.open-meteo.com/v1/forecast?latitude=' + lat + '&longitude=' + lon + '&current=temperature_2m,relative_humidity_2m,weather_code,wind_speed_10m&timezone=auto';
      return getJSON(url).then(function (d) {
        if (!d || !d.current || typeof d.current.temperature_2m !== 'number') throw new Error('empty');
        paint(place, d.current);
      }).catch(function () { ask('Live weather isn’t available right now.'); });
    }
    function lookup(name) {
      loading(name);
      return getJSON('https://geocoding-api.open-meteo.com/v1/search?count=1&language=en&format=json&name=' + encodeURIComponent(name)).then(function (d) {
        var g = d && d.results && d.results[0];
        if (!g) { ask('Couldn’t find “' + name + '”. Try another city.'); return; }
        var place = g.name;
        store('dv:wear:place', JSON.stringify({ n: place, lat: g.latitude, lon: g.longitude }));
        return load(place, g.latitude, g.longitude);
      }).catch(function () { ask('Live weather isn’t available right now.'); });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = (input.value || '').trim();
      if (v) lookup(v);
    });
    change.addEventListener('click', function () { ask('Enter a city to see its weather.'); input.value = ''; input.focus(); });

    /* Decide the state now (no network), then fetch after the page settles so
       weather never delays the product. */
    var saved = null;
    try { saved = JSON.parse(store('dv:wear:place') || 'null'); } catch (e) { saved = null; }
    if (!(saved && saved.n && saved.lat != null)) saved = null;
    var def = (card.getAttribute('data-default-city') || '').trim();
    if (!saved && !def) { ask('Enter your city to see today’s weather.'); return; }
    loading(saved ? saved.n : def);
    var start = function () {
      if (saved) load(saved.n, saved.lat, saved.lon);
      else lookup(def);
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 2500 });
    else window.setTimeout(start, 800);
  }

  /* ---------------- delivery estimate (pincode → date) ----------------
     Courier partner: Shipway. The date shown is today (India time) +
     preparation days + Shipway transit days.
     Transit days come from DIREVULF's live delivery-estimate service when the
     theme has one (settings.edd_endpoint — it keeps the Shipway login on the
     server and answers {serviceable, transit_days}); otherwise from
     assets/dv-shipway-transit.json, Shipway's courier transit times from our
     Hosur pickup to each 3-digit pincode area. Answers are kept in memory for
     this page view only (30 min), keyed by pincode+weight, and the date is
     always recomputed from today, so it can never go stale. */
  var EDD_TTL = 30 * 60 * 1000, eddCache = {}, transitTable = {};
  function istToday() {
    var p = {};
    try {
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', year: 'numeric', month: 'numeric', day: 'numeric' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
    } catch (e) { var d = new Date(); return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())); }
  }
  function eddDate(prep, transit) {
    var d = istToday();
    d.setUTCDate(d.getUTCDate() + prep + transit);
    try { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }); }
    catch (e) { return d.toUTCString().slice(0, 11); }
  }
  /* The Shipway transit table, fetched once per page and shared by every
     pincode box on it. Resolves to the parsed table, or null. */
  function loadTransit(url) {
    if (!url) return Promise.resolve(null);
    if (!transitTable[url]) {
      transitTable[url] = fetch(url, { credentials: 'omit', headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (t) { return t && t.days ? t : null; })
        .catch(function () { delete transitTable[url]; return null; });
    }
    return transitTable[url];
  }
  /* {serviceable, transit_days} for a pincode from the table: its 3-digit
     area first, then its 2-digit region. Unknown areas give null — no guess. */
  function fromTable(t, pin) {
    if (!t || !t.days) return null;
    var d = t.days[pin.slice(0, 3)];
    if (typeof d !== 'number' && t.regions) d = t.regions[pin.slice(0, 2)];
    return typeof d === 'number' ? { serviceable: true, transit_days: d, approx: true } : { unknown: true };
  }
  function initEdd() {
    $$('[data-dv-edd]').forEach(function (box) {
      if (box.__edd) return; box.__edd = true;
      var form = $('[data-dv-edd-form]', box), input = $('[data-dv-edd-pin]', box), out = $('[data-dv-edd-out]', box);
      var endpoint = (box.getAttribute('data-endpoint') || '').trim();
      var transitUrl = (box.getAttribute('data-transit') || '').trim();
      var prep = parseInt(box.getAttribute('data-prep'), 10); if (!(prep >= 0)) prep = 3;
      var weight = (box.getAttribute('data-weight') || '').trim();
      var seq = 0;
      function show(html, cls) { out.className = 'dv-edd__out' + (cls ? ' ' + cls : ''); out.innerHTML = html; out.hidden = false; }
      function ok(pin, transit) {
        show('<p class="dv-edd__to">Delivery to ' + esc(pin) + '</p>' +
             '<p class="dv-edd__k">Estimated delivery by</p>' +
             '<p class="dv-edd__date">' + esc(eddDate(prep, transit)) + '</p>' +
             '<p class="dv-edd__fine">Every order is quality checked before it ships.</p>');
      }
      function answer(pin, r) {
        if (r && r.serviceable === true && typeof r.transit_days === 'number' && r.transit_days >= 0 && r.transit_days < 60) ok(pin, Math.round(r.transit_days));
        else if (r && r.serviceable === false) show('Sorry, we can’t deliver to this pincode yet.', 'is-error');
        else if (r && r.unknown) show('We couldn’t estimate delivery for this pincode. Please check it, or write to support@direvulf.com.', 'is-error');
        else show('We couldn’t check delivery right now. Please try again.', 'is-error');
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var pin = (input.value || '').replace(/\s+/g, '');
        if (!/^[1-9][0-9]{5}$/.test(pin)) { show('Enter a valid 6-digit pincode.', 'is-error'); input.focus(); return; }
        if (!endpoint && !transitUrl) { show('Delivery estimates aren’t available right now.', 'is-error'); return; }
        var key = pin + '|' + weight, hit = eddCache[key];
        if (hit && Date.now() - hit.at < EDD_TTL) { answer(pin, hit.r); return; }
        var my = ++seq;
        form.setAttribute('aria-busy', 'true');
        show('Checking delivery…', 'is-busy');
        function done() { if (my === seq) form.removeAttribute('aria-busy'); }
        function viaTable() {
          return loadTransit(transitUrl).then(function (t) {
            if (my !== seq) return;
            var r = fromTable(t, pin);
            if (r) eddCache[key] = { at: Date.now(), r: r };
            answer(pin, r);
          });
        }
        if (!endpoint) { viaTable().then(done, done); return; }
        var url = endpoint + (endpoint.indexOf('?') === -1 ? '?' : '&') + 'pin=' + pin + (weight ? '&w=' + encodeURIComponent(weight) : '');
        var ctl = window.AbortController ? new AbortController() : null;
        var timer = ctl ? setTimeout(function () { ctl.abort(); }, 12000) : null;
        fetch(url, { credentials: 'omit', headers: { 'Accept': 'application/json' }, signal: ctl ? ctl.signal : undefined })
          .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
          .then(function (r) {
            if (my !== seq) return;
            if (r && (r.serviceable === false || (r.serviceable === true && typeof r.transit_days === 'number'))) { eddCache[key] = { at: Date.now(), r: r }; answer(pin, r); return; }
            return viaTable();
          })
          .catch(function () { if (my === seq) return viaTable(); })
          .then(function () { if (timer) clearTimeout(timer); done(); }, function () { if (timer) clearTimeout(timer); done(); });
      });
    });
  }

  function init() {
    $$('[data-sg-guide]').forEach(function (d) { if (d.__sg) return; d.__sg = true; initTabs(d); initPick(d); });
    $$('[data-fms]').forEach(function (d) { if (d.__sg) return; d.__sg = true; initFindMySize(d); initPick(d); });
    initSummary();
    initWear();
    initEdd();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
